import React from 'react'

import { Input } from '@cvg/react-components'

import { useFiltersContext } from '@contexts/FilterContext'
import { DROPDOWN_CATEGORIES } from '@utils/constants'

const Categories = () => {
  const { filters, setFilter } = useFiltersContext()

  return (
    <Input
      name='categories'
      label='Categories'
      type='multiselect'
      displayOptions={{
        showAllOptions: false,
        showUnselectedLabel: filters.categories.length ? 'Add Category' : 'Show Categories',
        hideUnselectedLabel: 'Hide Unselected Categories'
      }}
      options={DROPDOWN_CATEGORIES}
      selected={filters.categories}
      onSelect={categories => setFilter({ categories })}
    />
  )
}

export default Categories
